module.exports = __webpack_public_path__ + "static/media/3.c5ba1ea6.jpg";